
<dropdown
  :align="align"
  :active="menuOpen"
  @close="menuOpen = false"
>
  <btn
    icon="arrow_drop_down"
    v-bind="$attrs"
    @click="menuOpen = !menuOpen"
  >
    {{ label }}
  </btn>

  <template #menu>
    <dropdown-menu
      :options="options"
      @select="handleSelect"
    />
  </template>
</dropdown>
